import React from 'react';
import { motion } from 'framer-motion';
import { Calendar, Tag, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
export function BookingCTA() {
  return <section id="book" className="py-20 lg:py-32 bg-white" data-id="element-30">
      <div className="max-w-5xl mx-auto px-6 lg:px-8" data-id="element-31">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.7
      }} className="bg-sage rounded-[3rem] p-10 md:p-16 text-center relative overflow-hidden" data-id="element-32">
          {/* Decorative circles */}
          <div className="absolute top-0 right-0 -mr-20 -mt-20 w-64 h-64 rounded-full bg-sage-400/30 blur-2xl pointer-events-none" data-id="element-33"></div>
          <div className="absolute bottom-0 left-0 -ml-20 -mb-20 w-64 h-64 rounded-full bg-sage-600/30 blur-2xl pointer-events-none" data-id="element-34"></div>

          <div className="relative z-10 max-w-2xl mx-auto" data-id="element-35">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-coral text-white font-medium text-sm mb-6 shadow-sm" data-id="element-36">
              <Tag size={16} data-id="element-37" />
              <span data-id="element-38">New Patient Special — $69</span>
            </div>

            <h2 className="text-4xl md:text-5xl font-serif text-white mb-6 leading-tight" data-id="element-39">
              Exam, 4 BW X-rays &amp; cleaning — just $69.
            </h2>
            <p className="text-sage-50 text-lg mb-10" data-id="element-40">
              Just mention this website when you book. We're accepting new
              patients at both our Lincoln and Waverly offices.
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-41">
              <Link to="/appointments" className="w-full sm:w-auto flex items-center justify-center gap-2 bg-coral hover:bg-coral-600 text-white px-8 py-4 rounded-full font-medium text-lg transition-all hover:shadow-lg hover:-translate-y-0.5 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-sage" data-id="element-42">
                <Calendar size={20} data-id="element-43" />
                <span data-id="element-44">How to Book</span>
                <ArrowRight size={18} data-id="element-45" />
              </Link>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}